import React from "react";
import { Route } from "react-router-dom";
import AboutUs from "../pages/AboutUs";
import AboutManet from "../page_content/AboutSection/about_manet/AboutManet";
import VisionMission from "../page_content/AboutSection/vision_mission/VisionMission";
import AboutMIT from "../page_content/AboutSection/about_mit/AboutMIT";
import BoardOfBodies from "../page_content/AboutSection/board_of_bodies/BoardOfBodies";
import PrincipalsDesk from "../page_content/AboutSection/principals_desk/PrincipalsDesk";
import Awards from "../page_content/AboutSection/awards/Awards";
import Accreditations from "../page_content/AboutSection/accreditations/Accreditations";

export const AboutRoutes = (
  <Route path="aboutus" element={<AboutUs />}>
    <Route path="about-manet" element={<AboutManet />} />
    <Route path="vision-mission" element={<VisionMission />} />
    <Route path="mit-group" element={<AboutMIT />} />
    <Route path="board-bodies" element={<BoardOfBodies />} />
    <Route path="principals-desk" element={<PrincipalsDesk />} />
    <Route path="awards" element={<Awards />} />
    <Route path="accreditations" element={<Accreditations />} />
  </Route>
);

